require("./init");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueLocalStorage from 'vue-localstorage';
import { sync } from 'vuex-router-sync';
import VueClipboard from 'vue-clipboard2';
import VueCookies from 'vue-cookies';
import VueForceNextTick from 'vue-force-next-tick'

// Spinners
import { HalfCircleSpinner } from 'epic-spinners';

// Bootstrap-vue
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import BootstrapVue from 'bootstrap-vue';

// Date time picker
import datePicker from 'vue-bootstrap-datetimepicker';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'glyphicons-only-bootstrap/css/bootstrap.min.css';

// Font Awesome
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/user';
import 'vue-awesome/icons/key';
import 'vue-awesome/icons/eye';
import 'vue-awesome/icons/check';
import 'vue-awesome/icons/times';
import 'vue-awesome/icons/user-plus';
import 'vue-awesome/icons/user-circle';
import 'vue-awesome/icons/stop';
import 'vue-awesome/icons/edit';
import 'vue-awesome/icons/plus';
import 'vue-awesome/icons/archive';
import 'vue-awesome/icons/briefcase';
import 'vue-awesome/icons/ban';
import 'vue-awesome/icons/calculator';
import 'vue-awesome/icons/check-square';
import 'vue-awesome/icons/square';
import 'vue-awesome/icons/trash-alt';
import 'vue-awesome/icons/eye';

// Global app css
import './assets/dist/css/global/global.css';
import './assets/scss/theme.scss';

// In app
import router from './router';
import store from './store';
import AuthService from './services/AuthService';
import ViewPortService from './services/ViewPortService';

// Components
import App from './App';
import GlobalSpinner from './components/utils/GlobalSpinner';
import Spinner from './components/utils/Spinner';
import GlobalToaster from './components/utils/GlobalToaster';
import BarStickyBottom from './components/utils/BarStickyBottom';
import ProfileType from './components/form/user/ProfileType';
import RegisterType from './components/form/user/RegisterType';
import RolesType from './components/form/user/RolesType';
import ResetPasswordType from './components/form/user/ResetPasswordType';
import UserInputType from './components/form/user/input/UserInputType';
import OasiceEditCreateInputType from './components/form/OasiceEditCreateInputType';
import OasiceNumberInputType from './components/form/OasiceNumberInputType';
import EnedisCaseType from './components/form/EnedisCaseType';
import GapHistoryType from './components/form/GapHistoryType';
import TrancheType from './components/form/TrancheType';
import TrancheCreateType from './components/form/TrancheCreateType';
import TrancheUpdateClassAType from './components/form/TrancheUpdateClassAType';
import ValidationErrorAlert from './components/form/validation/ValidationErrorAlert';
import SelectCaseManager from './components/form/select/SelectCaseManager';
import SelectAgent from './components/form/select/SelectAgent';
import UserTable from './components/tables/UserTable';
import GapHistoriesTable from './components/tables/GapHistoriesTable';
import ShowUserProfileButton from './components/button/ShowUserProfileButton';
import DeleteConfirmButton from './components/button/DeleteConfirmButton';
import AddEditEnedisCaseButton from './components/button/AddEditEnedisCaseButton';
import ShowGapHistoryTypeButton from './components/button/ShowGapHistoryTypeButton';

// Apexcharts
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Apex.legend = {
  position: 'bottom',
  horizontalAlign: 'center',
};
Apex.dataLabels = {
  dropShadow: {
    enabled: true,
    top: 1,
    left: 1,
    opacity: 0.8
  }
};
Apex.colors = [
  '#9575CD',
  '#FCCC49',
  '#EF5350',
  '#61D5F0',
  '#58C79C',
  '#BEC4CE'
];

// Spinners
Vue.component('half-circle-spinner', HalfCircleSpinner);
Vue.component('GlobalSpinner', GlobalSpinner);
Vue.component('Spinner', Spinner);

// Utils
Vue.component('GlobalToaster', GlobalToaster);
Vue.component('BarStickyBottom', BarStickyBottom);

// Form type
Vue.component('ProfileType', ProfileType);
Vue.component('RegisterType', RegisterType);
Vue.component('UserInputType', UserInputType);
Vue.component('OasiceEditCreateInputType', OasiceEditCreateInputType);
Vue.component('OasiceNumberInputType', OasiceNumberInputType);
Vue.component('EnedisCaseType', EnedisCaseType);
Vue.component('GapHistoryType', GapHistoryType);
Vue.component('TrancheType', TrancheType);
Vue.component('TrancheCreateType', TrancheCreateType);
Vue.component('RolesType', RolesType);
Vue.component('ResetPasswordType', ResetPasswordType);
Vue.component('TrancheUpdateClassAType', TrancheUpdateClassAType);
Vue.component('ValidationErrorAlert', ValidationErrorAlert);

// Select
Vue.component('SelectCaseManager', SelectCaseManager);
Vue.component('SelectAgent', SelectAgent);

// Table
Vue.component('UserTable', UserTable);
Vue.component('GapHistoriesTable', GapHistoriesTable);

// Button
Vue.component('ShowUserProfileButton', ShowUserProfileButton);
Vue.component('DeleteConfirmButton', DeleteConfirmButton);
Vue.component('AddEditEnedisCaseButton', AddEditEnedisCaseButton);
Vue.component('ShowGapHistoryTypeButton', ShowGapHistoryTypeButton);

// Bootstrap-vue
Vue.use(BootstrapVue);

// Vue-cookies
Vue.use(VueCookies);

// Vue Awesome configuration
Vue.component('icon', Icon);

// Date Picker
Vue.use(datePicker);

Vue.config.productionTip = false;

// Viewport
ViewPortService.setResizeEvent();

// Vue Local Storage
Vue.use(VueLocalStorage);
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard);

// Force NextTick component
Vue.use(VueForceNextTick);

// Vue resource configuration
Vue.use(VueResource);
Vue.http.options.root = process.env.ROOT_API;
Vue.http.interceptors.push((request, next) => {
  // console.log('header : ', request);
  // Change headers ContentType and set Authorization if not in black list
  AuthService.setHeaders(request);
  next();
});

// Synchronize data store and router to get route's info from store
sync(store, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created: function () {
    this.$store.commit('setGlobalSpinnerShow', true);
    axios.interceptors.request.use((config) => {
      this.$store.commit('setGlobalSpinnerShow', true);
        return config;
    }, (error) => {
        this.$store.commit('setGlobalSpinnerShow', false);
        return Promise.reject(error);
    });
    axios.interceptors.response.use((response) => {
        this.$store.commit('setGlobalSpinnerShow', false);
        return response;
    }, (error) => {
        this.$store.commit('setGlobalSpinnerShow', false);
        return Promise.reject(error);
    });
  },
  mounted() {
      this.$store.commit('setGlobalSpinnerShow', false);
  }
});



// WEBPACK FOOTER //
// ./src/main.js